import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import Editor from './Editor';

function DeleteProfile() {
  const navigate = useNavigate();
  const { id } = useParams();
  
  const handleClose = useCallback(() => navigate(`/account/${id ?? ''}`), [navigate, id]);
  
  return (
    <Routes>
      <Route path="deleteProfile" element={<Editor onClose={handleClose} />} />
    </Routes>
  );
}

DeleteProfile.propTypes = {};

export default DeleteProfile;
